import React from 'react'
import "../css/policies.css"


const Refund = () => {
  return (
    <div className='policy-p'>
      <h1 style={{ textAlign: "center" }}>Refund and Cancellation Policy</h1><br />
      <p>
        <h5><b>1. No Refund Policy</b></h5>
        All donations made on our website are final and non-refundable. Once a donation is processed, it cannot be refunded or reversed under any circumstances.
      </p>
      <p>
        <h5><b>2. No Cancellation Policy</b></h5>
        Donations cannot be canceled once they are submitted. Please ensure the accuracy of your donation details before confirming your contribution.
      </p>
      <p>
        <h5><b>3. Exceptions</b></h5>
        In rare cases of a technical error (e.g., duplicate transactions or incorrect amounts due to system malfunction), we may review the case at our sole discretion. If you believe an error has occurred, please contact us at [support email/phone number] within 7 days of the transaction.
      </p>
      <p>
        <h5><b>4. Acknowledgment</b></h5>
        By making a donation through our website, you acknowledge that you have read, understood, and agreed to this Refund and Cancellation Policy
      </p><br />
      <p>
        <h5><b>Contact Us</b></h5>
        For any questions or concerns regarding your donation, please contact <b>Daji Maharaj Devsthan Takli.</b> <br />
        <b>Email: svspgurukul@gmail.com</b>  <br />
        <b>Phone: 9158303000</b>  <br />
        Thank you for supporting our mission and helping us make a difference.
      </p>
    </div>
  )
}

export default Refund